import { Box, Checkbox, FormControlLabel } from "@mui/material";
import VideoContent from "./VideoContent";
import VideoInput from "./VideoInput";

function VideoComponent({
  contentId,
  mandatory,
  sx,
  value,
  onChange,
  hideControls,
  setHideControls,
  quadrantData = {},
  isEditing = false,
  ...props
}) {
  const { confidential } = quadrantData;

  if (isEditing) {
    return (
      <>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            p: 1,
          }}
        >
          <VideoInput sx={sx} onChange={onChange} videoUrl={value} />
          <FormControlLabel
            control={
              <Checkbox
                checked={hideControls === "S"}
                onChange={(event) =>
                  setHideControls(event.target.checked ? "S" : "N")
                }
              />
            }
            label="Ocultar controles do player"
          />
          {value && (
            <VideoContent
              isConfidential={confidential === "S"}
              contentId={quadrantData?.chapterContentId}
              mandatory={mandatory}
              sx={sx}
              url={value}
              isEditing={isEditing}
              hideControls={
                hideControls === "S" || quadrantData.removePlayerControl === "S"
              }
            />
          )}
        </Box>
      </>
    );
  }
  return (
    <VideoContent
      isConfidential={confidential === "S"}
      contentId={quadrantData?.chapterContentId}
      mandatory={mandatory}
      sx={sx}
      url={value}
      hideControls={
        hideControls === "S" || quadrantData.removePlayerControl === "S"
      }
      isEditing={isEditing}
      {...props}
    />
  );
}

export default VideoComponent;
